module.exports = __webpack_public_path__ + "img/HelveticaNeueCyrThin.f3b4b40.svg";